import { render } from "./QuestionBarChart.vue?vue&type=template&id=103bc226"
import script from "./QuestionBarChart.vue?vue&type=script&lang=js"
export * from "./QuestionBarChart.vue?vue&type=script&lang=js"
script.render = render

export default script